import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoHeader = _resolveComponent("IoHeader")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_IoFooter = _resolveComponent("IoFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_IoHeader),
    _createVNode(_Transition, {
      name: "loader-animation",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ProgressBar, {
          "show-loader": _ctx.isLoading,
          "loader-style": _ctx.loaderStyle
        }, null, 8, ["show-loader", "loader-style"])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view),
    _createVNode(_component_IoFooter)
  ], 64))
}